import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-a4fc72b8"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ba-product-info-block state"
};
const _hoisted_2 = ["id"];
const _hoisted_3 = {
  class: "campaign_state_warning"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_spinner = _resolveComponent("b-spinner");
  const _component_pause_icon = _resolveComponent("pause-icon");
  const _component_play_icon = _resolveComponent("play-icon");
  const _component_alert = _resolveComponent("alert");
  const _component_state_switch = _resolveComponent("state-switch");
  const _component_app_popover = _resolveComponent("app-popover");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    id: $props.item_id
  }, [$props.loading ? (_openBlock(), _createBlock(_component_b_spinner, {
    key: 0,
    small: ""
  })) : (_openBlock(), _createBlock(_component_state_switch, {
    key: 1,
    modelValue: $options.State,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $options.State = $event),
    style: {
      "margin-top": "5px"
    }
  }, {
    "icon-unchecked": _withCtx(() => [_createVNode(_component_pause_icon)]),
    "icon-checked": _withCtx(() => [_createVNode(_component_play_icon)]),
    "intermediate-state": _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_alert, {
      class: "campaign_state_warning_icon"
    })])]),
    _: 1
  }, 8, ["modelValue"]))], 8, _hoisted_2), $options.State === 'inconsistent' ? (_openBlock(), _createBlock(_component_app_popover, {
    key: 0,
    target: $props.item_id,
    "gray-arrow": "",
    "auto-width": "",
    placement: "top",
    popup: "",
    delay: {
      show: 0,
      hide: 200
    }
  }, {
    default: _withCtx(() => [_renderSlot(_ctx.$slots, "default", {}, undefined, true)]),
    _: 3
  }, 8, ["target"])) : (_openBlock(), _createBlock(_component_app_popover, {
    key: 1,
    target: $props.item_id,
    "auto-width": "",
    placement: "top"
  }, {
    default: _withCtx(() => [_createElementVNode("div", null, _toDisplayString($options.State ? "Activated" : "Deactivated"), 1)]),
    _: 1
  }, 8, ["target"]))]);
}